import { useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { Loading, useMedplum } from "@medplum/react";

export default function Logout() {
  const medplum = useMedplum();
  const navigate = useNavigate();
  const handleSignOut = useCallback(async () => {
    try {
      await medplum.signOut();
    } catch (error) {
      console.error("Error signing out:", error);
    } finally {
      // Always leave /logout so in-flight Medplum requests cannot 401 on a stuck logout page.
      navigate("/", { replace: true });
    }
  }, [medplum, navigate]);

  useEffect(() => {
    handleSignOut();
  }, [handleSignOut]);

  return <Loading />;
}
